/* Behaviour for the vt- sections: countdown, sliders, counters, gallery, bundle picker, sticky bar, videos. */
(function () {
  'use strict';

  function each(root, sel, fn) {
    (root || document).querySelectorAll(sel).forEach(fn);
  }

  /* ---------- countdown ---------- */
  function initCountdown(el) {
    if (el.dataset.vtReady) return;
    el.dataset.vtReady = '1';
    var mode = el.dataset.mode;
    var end = el.dataset.end ? new Date(el.dataset.end).getTime() : NaN;
    var h = el.querySelector('[data-h]');
    var m = el.querySelector('[data-m]');
    var s = el.querySelector('[data-s]');
    function pad(n) {
      return String(Math.max(0, n)).padStart(2, '0');
    }
    function target() {
      if (mode === 'daily') {
        var d = new Date();
        d.setHours(24, 0, 0, 0);
        return d.getTime();
      }
      return end;
    }
    function tick() {
      var t = target();
      var left = isNaN(t) ? 0 : Math.max(0, Math.floor((t - Date.now()) / 1000));
      h.textContent = pad(Math.floor(left / 3600));
      m.textContent = pad(Math.floor((left % 3600) / 60));
      s.textContent = pad(left % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- sliders ---------- */
  function initSlider(el) {
    if (el.dataset.vtReady) return;
    el.dataset.vtReady = '1';
    var track = el.querySelector('[data-track]');
    var prev = el.querySelector('[data-prev]');
    var next = el.querySelector('[data-next]');
    var dotsWrap = el.querySelector('[data-dots]');
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    var dots = [];
    if (dotsWrap) {
      items.forEach(function (item, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () {
          track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }
    function step() {
      var first = items[0];
      if (!first) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      if (dots.length) {
        var i = Math.round(track.scrollLeft / (step() || 1));
        if (track.scrollLeft >= max) i = Math.max(i, items.length - Math.round(track.clientWidth / (step() || 1)));
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === Math.min(i, dots.length - 1));
        });
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- counters ---------- */
  function initCounter(el) {
    if (el.dataset.vtReady) return;
    el.dataset.vtReady = '1';
    var to = parseFloat(el.dataset.vtCount) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      el.textContent = to;
      return;
    }
    el.textContent = '0';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        var start = null;
        function frame(ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / 1400);
          el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
          if (p < 1) window.requestAnimationFrame(frame);
        }
        window.requestAnimationFrame(frame);
      });
    }, { threshold: 0.4 });
    io.observe(el);
  }

  /* ---------- product: gallery ---------- */
  function initGallery(el) {
    if (el.dataset.vtReady) return;
    el.dataset.vtReady = '1';
    var media = el.querySelectorAll('[data-media]');
    var thumbs = el.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        media.forEach(function (m, n) {
          m.classList.toggle('is-active', n === i);
          var v = m.querySelector('video');
          if (v && n !== i) v.pause();
        });
        thumbs.forEach(function (x, n) {
          x.classList.toggle('is-active', n === i);
          x.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- product: bundle picker + subscribe ---------- */
  function initBuyBox(root) {
    if (root.dataset.vtReady) return;
    root.dataset.vtReady = '1';
    var radios = root.querySelectorAll('[data-bundle] input[type="radio"]');
    var sub = root.querySelector('[data-subscribe]');
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var planInput = form.querySelector('[name="selling_plan"]');
    var submit = form.querySelector('[type="submit"]');
    var stickyBtn = root.querySelector('[data-sticky] [type="submit"]');

    function apply() {
      var subscribing = !!(sub && sub.checked);
      var chosen = null;
      radios.forEach(function (r) {
        var card = r.closest('[data-bundle]');
        card.classList.toggle('is-selected', r.checked);
        if (r.checked) chosen = r;
        var usePlan = subscribing && r.dataset.plan;
        var price = card.querySelector('[data-price]');
        var compare = card.querySelector('[data-compare]');
        var save = card.querySelector('[data-save]');
        if (price && price.dataset.auto) price.textContent = usePlan ? price.dataset.sub : price.dataset.once;
        if (compare && compare.dataset.auto) {
          var c = usePlan ? compare.dataset.sub : compare.dataset.once;
          compare.textContent = c;
          compare.hidden = !c;
        }
        if (save && save.dataset.auto) {
          var t = usePlan ? save.dataset.sub : save.dataset.once;
          save.textContent = t;
          save.hidden = !t;
        }
      });
      if (!chosen) return;
      idInput.value = chosen.value;
      if (qtyInput) qtyInput.value = chosen.dataset.qty || 1;
      if (planInput) {
        var plan = subscribing ? chosen.dataset.plan : '';
        planInput.value = plan || '';
        planInput.disabled = !plan;
      }
      var available = chosen.dataset.available === 'true';
      [submit, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !available;
        var label = b.querySelector('span');
        if (label) label.textContent = available ? b.dataset.label : b.dataset.soldOut;
      });
    }
    radios.forEach(function (r) { r.addEventListener('change', apply); });
    if (sub) sub.addEventListener('change', apply);
    if (radios.length) apply();

    /* sticky add to cart */
    var sticky = root.querySelector('[data-sticky]');
    if (sticky && submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var past = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', past);
          sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        });
      }).observe(submit);
    }
  }

  /* ---------- video tiles ---------- */
  function initVideo(el) {
    if (el.dataset.vtReady) return;
    el.dataset.vtReady = '1';
    var btn = el.querySelector('[data-play]');
    var video = el.querySelector('video');
    if (!btn || !video) return;
    btn.addEventListener('click', function () {
      each(document, '[data-vt-video].is-playing video', function (v) { v.pause(); });
      video.controls = true;
      video.play();
    });
    video.addEventListener('play', function () { el.classList.add('is-playing'); });
    video.addEventListener('pause', function () { el.classList.remove('is-playing'); });
  }

  /* ---------- slide-open panels (details elements) ---------- */
  function initDetails(el) {
    if (el.dataset.vtReady) return;
    el.dataset.vtReady = '1';
    var summary = el.querySelector('summary');
    var panel = el.querySelector('[data-vt-panel]');
    if (!summary || !panel || !el.animate) return;
    var anim = null;
    var closing = false;
    var expanding = false;

    function edges() {
      return el.offsetHeight - el.clientHeight;
    }
    function finish(open) {
      el.open = open;
      anim = null;
      closing = false;
      expanding = false;
      el.classList.remove('is-closing');
      el.style.height = '';
      el.style.overflow = '';
    }
    function run(from, to, open) {
      if (anim) anim.cancel();
      anim = el.animate({ height: [from + 'px', to + 'px'] }, { duration: 320, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' });
      anim.onfinish = function () { finish(open); };
      anim.oncancel = function () {
        closing = false;
        expanding = false;
      };
    }
    function shrink() {
      closing = true;
      el.classList.add('is-closing');
      run(el.offsetHeight, summary.offsetHeight + edges(), false);
    }
    function expand() {
      expanding = true;
      el.classList.remove('is-closing');
      run(el.offsetHeight, summary.offsetHeight + panel.offsetHeight + edges(), true);
    }

    summary.addEventListener('click', function (e) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      e.preventDefault();
      el.style.overflow = 'hidden';
      if (closing || !el.open) {
        el.style.height = el.offsetHeight + 'px';
        el.open = true;
        window.requestAnimationFrame(expand);
      } else if (expanding || el.open) {
        shrink();
      }
    });
  }

  function init(root) {
    each(root, '[data-vt-details]', initDetails);
    each(root, '[data-vt-countdown]', initCountdown);
    each(root, '[data-vt-slider]', initSlider);
    each(root, '[data-vt-count]', initCounter);
    each(root, '[data-vt-gallery]', initGallery);
    each(root, '[data-vt-buybox]', initBuyBox);
    each(root, '[data-vt-video]', initVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
